export default __webpack_public_path__ + "static/media/modulo-4.7bd19869.svg";